import { featureFlagKeySchema } from "@redotech/feature-flags-model/schema";
import * as z from "zod";

export const getUserFeatureFlag = {
  name: "getUserFeatureFlag" as const,
  input: z.object({
    flagKey: featureFlagKeySchema,
    defaultValue: z.boolean().nullish(),
  }),
  output: z.object({ enabled: z.boolean() }),
};
